import React from "react";
import {
  Typography,
  Button,
  useMediaQuery
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useSearchParams, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import axios from "axios";
import { obtenerCostoProductos, obtenerPuntosProductos } from "../../utils/products/products";
import { getBuytById } from "../../utils/buys/buys";
import { getUserById } from "../../features-slice/user/functions";



export default function Success() {
  const [searchParams] = useSearchParams();
  const paymentId = searchParams.get("payment_id");
  const externalReference = searchParams.get("external_reference");
  const navigate = useNavigate();
  const carrito = useSelector((state) => state.carrito);
  const user = useSelector((state) => state.user);
  const isMobile = useMediaQuery('(max-width:768px)');


  const [dataCompra, setDataCompra] = React.useState(null);
  const [costoTarjeta, setCostoTarjeta] = React.useState(0);


  const[datosContacto, setDatosContacto] = React.useState({
    nombre:"",
    apellido:"",
    telefono:""
  })

const handleChange = (e) => {
  e.preventDefault(); // Solo necesario si el evento es de un form submit
  const { name, value } = e.target;

  setDatosContacto(prevData => ({
    ...prevData,
    [name]: value,
  }));
};



  const [formData, setFormData] = React.useState({
    total: 0,
    estadoCompra: "FINALIZADA",
    metodoPago: "MERCADO_PAGO",
    idPago: paymentId,
    mediosPago: [{ medioPago: "67e97074c2f4e6d5bbee93e3", monto: 0 }],
    atendidoPor: "668003036088d4bb1108d5e5",
    datosContacto:{}
  });

  const [loading, setLoading] = React.useState(false);
  const dispatch = useDispatch();

    const fetchUserData = async () => {
        try {
       
          dispatch(getUserById(user?._id)); // Actualizamos los datos del usuario en el store de Redux
        } catch (error) {
          console.error("Error al obtener los datos del usuario:", error);
        } finally {
   
        }
      };
    

  const formatDetalleToText = (detalle) => {
        let formattedText = '';
        detalle.forEach((item) => {
          formattedText += `\n-${item.nombre} - Cantidad: *${item.cantidad}*, Precio: *${item.precioElegido}*, Perlas: *${item.puntos || 0}*\n\n`;
        });
        return formattedText;
      };
  

  React.useEffect(() => {
    if (externalReference) {
      const obtenerCompra = async () => {
        try {
          const dataPur = await getBuytById(externalReference);
          setDataCompra(dataPur);
        } catch (error) {
          toast.error("Hubo un error obteniendo la compra");
        }
      };
      obtenerCompra();
    }
  }, [externalReference, paymentId]);

  React.useEffect(() => {
    if (!dataCompra) return;
    const costo = obtenerCostoProductos(dataCompra?.detalle, "TARJETA");
    setCostoTarjeta(costo);
    setFormData((prevFormData) => ({
      ...prevFormData,
      total: costo,
      mediosPago: [{ medioPago: "67e97074c2f4e6d5bbee93e3", monto: costo }]
    }));
  }, [dataCompra]);

  const token = localStorage.getItem("Token");
  const config = {
    headers: {
      xtoken: token
    }
  };
  //console.log(config)
  const handleEditPurchase = async () => {
    if (loading) return;
    if (!dataCompra || !formData.total) {
      toast.error("Faltan datos para continuar");
      return;
    }
const formDataConContacto = {
  ...formData,
  datosContacto: datosContacto,
};

setLoading(true);
try {
  await axios.put(
    `${process.env.REACT_APP_BACK_URL}/api/compras/${dataCompra?._id}`,
    formDataConContacto,
    config
  );
      const event = new Event("actualizar-compra");
      window.dispatchEvent(event);
      toast.success("Compra ingresada/actualizada con éxito");
const detalleTexto = formatDetalleToText(dataCompra?.detalle);
                const numero = '+543415140700';
                const mensajeCompra = `Hola Marketina! soy ${dataCompra?.cliente?.nombre} y acabo de pagar mi pedido:\n${detalleTexto}\n idCompra: *${dataCompra._id.slice(0,5)}* \n método de pago elegido: ${formData?.metodoPago}`;
                const encodedMensaje = encodeURIComponent(mensajeCompra);
                const whatsappLink = `https://api.whatsapp.com/send?phone=${numero}&text=${encodedMensaje}`;
        
                localStorage.removeItem('cc');
                
                
                setTimeout(() => {
                  window.open(whatsappLink, '_blank');
                }, 1500);

              fetchUserData()
      setTimeout(() => {
        navigate("/markethome");
      }, 2000);
    } catch (error) {
      console.log(error);
      toast.error("Error al editar compra");
    } finally {
      setLoading(false);
    }
  };
//console.log(user)
  return (
    <div
      style={{
        minWidth: "100vw",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <Typography
        sx={{
          fontFamily: "Poppins",
          color: "black",
          fontSize: !isMobile?"24px":"18px",
          fontWeight: 400,
          mb: 2
        }}
      >
        Tu pago se recibió con éxito
      </Typography>

        
      <p
        sx={{
          fontFamily: "Poppins",
          color: "black",
          fontSize: isMobile?"14px":"18px",
          fontWeight: 400,
justifySelf:"center",
alignSelf:"center",
          mb: 2
        }}
      >
        Envianos tu comprobante para que podamos imputar el pago
      </p>
{/* n */}
      <Button
  variant="contained"
  sx={{
    marginTop: "5vh",
    width: isMobile ? "90%" : "30%",
    height: "48px",
    backgroundColor: "#23563F",
    fontFamily: "Poppins",
    fontSize: "14px",
    fontWeight: 400,
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#1c4634"
    },
    opacity: loading ? 0.7 : 1
  }}
  onClick={() => {
        handleEditPurchase();
      }}
  disabled={
    loading
  }
>
  {loading ? "Procesando..." : "Continuar"}
</Button>
    </div>
  );
}
